import PropertyViewData, { IPropertyViewData } from "../property/PropertyViewData";

export interface IKeyedInPropertyData {
    property: IPropertyViewData,
    target: number,
    sigma: number,
    gain: number,
    offset: number,
    minValue: number,
    maxValue: number,
    alarmLow1: number,
    alarmHigh1: number,
    alarmLow2: number,
    alarmHigh2: number,
    rejectLow: number,
    rejectHigh: number,
    order?: number,
    sigmaPercent: boolean
}

export default class KeyedInPropertyData implements IKeyedInPropertyData {
    property: IPropertyViewData;
    target: number;
    sigma: number;
    gain: number;
    offset: number;
    minValue: number;
    maxValue: number;
    alarmLow1: number;
    alarmHigh1: number;
    alarmLow2: number;
    alarmHigh2: number;
    rejectLow: number;
    rejectHigh: number;
    order?: number;
    sigmaPercent: boolean;

    constructor(property: IPropertyViewData, target: number, sigma: number, gain: number, offset: number, minValue: number,
        maxValue: number, alarmLow1: number, alarmHigh1: number, alarmLow2: number, alarmHigh2: number, rejectLow: number,
        rejectHigh: number, order?: number, sigmaPercent?: boolean) {
        this.property = property;
        this.target = target;
        this.sigma = sigma;
        this.gain = gain;
        this.offset = offset;
        this.minValue = minValue;
        this.maxValue = maxValue;
        this.alarmLow1 = alarmLow1;
        this.alarmHigh1 = alarmHigh1;
        this.alarmLow2 = alarmLow2;
        this.alarmHigh2 = alarmHigh2;
        this.rejectLow = rejectLow;
        this.rejectHigh = rejectHigh;
        this.order = order;
        this.sigmaPercent = sigmaPercent;
    }
}

const defaultKeyedInPropertiesData = new KeyedInPropertyData(new PropertyViewData("", "", "", 0, "", "", "", 0), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
export { defaultKeyedInPropertiesData };
